import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useSpring, animated } from "@react-spring/web";
import Colloboration from "../../assets/Colloborate.png";

const FlipCard = ({ title, content, icon }) => {
  const [flipped, setFlipped] = React.useState(false);

  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `rotateY(${flipped ? 180 : 0}deg)`,
    config: { tension: 300, friction: 25 },
  });

  return (
    <Box
      sx={{
        perspective: "1200px",
        width: "320px",
        height: "150px",
        position: "relative",
        cursor: "pointer",
        "&:hover": {
          transform: "scale(1.1)",
        },
        "&:hover .card-front": {
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
        },
      }}
      onClick={() => setFlipped(!flipped)}
    >
      <Tooltip title="Click to know more">
        <animated.div
          style={{
            opacity: opacity.to((o) => 1 - o),
            transform,
          }}
          className="card-front"
        >
          <Box
            sx={{
              backgroundColor: "#ffffff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              borderRadius: "16px",
              border: "1px solid #e0e0e0",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              padding: "20px",
            }}
          >
            <IconButton
              sx={{
                borderRadius: 0,
                padding: 0,
                background: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Box
                component="img"
                src={icon}
                alt="Custom Icon"
                sx={{
                  width: 80,
                  height: 80,
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",

                marginBottom: "10px",
              }}
            >
              {title}
            </Typography>
          </Box>
        </animated.div>

        <animated.div
          style={{
            opacity,
            transform: transform.to((t) => `${t} rotateY(180deg)`),
            position: "absolute",
            top: 0,
            left: 0,
          }}
          className="card-back"
        >
          <Box
            sx={{
              backgroundColor: "#333",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: "1rem",
                fontStyle: "italic",
                lineHeight: 1.8,
                color: "#FFD700",
              }}
            >
              {content}
            </Typography>
          </Box>
        </animated.div>
      </Tooltip>
    </Box>
  );
};

export default FlipCard;
